import { Component, OnInit } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { Router, NavigationEnd, Event } from '@angular/router';
import { ApiDataService } from '../../services/api.service';
import { ShService } from '../../services/sh-service';
import { ToastrService } from 'ngx-toastr';
import { QuickNotificationComponent } from "../quick-notification/quick-notification.component";
import { MasterSearchComponent } from "../master-search/master-search.component";

@Component({
    selector: 'app-header',
    imports: [SharedModule, QuickNotificationComponent, MasterSearchComponent],
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit {
  pageTitle: string = 'Dashboard';
  userName: string = '';
  userRole: any;
  displayRole: string = '';
  userOrg: string = '';
  userOrgName: string = '';
  currentProfile: number = -1;
  currentOrg: any = '';
  currentOrgDisplay: string = '';
  currentLob: string = '';
  currentLobDisplay: string = '';
  orgList: any;
  orgListDisplay: any;
  profileImg: string = '';
  defaultAvatar: string = './img/avtar2.png';
  labels: any;
  lobList: string[] = [];
  lobColor: any;
  orgInfo: any

  constructor(
    private router: Router,
    private _apiService: ApiDataService,
    private _service: ShService,
    private toastr: ToastrService
  ){}

  ngOnInit(): void {
    this.labels = JSON.parse(sessionStorage.getItem('labels') as any);
    this._service.orgInfo$.subscribe(x => {
      this.orgInfo = x;
    });

    this.router.events.subscribe((event: Event) => {
      if(event instanceof NavigationEnd) {
        this.pageTitle = event.url.toLowerCase().split('/')[1].split('?')[0];
      this.pageTitle === '3pl'? this.pageTitle = '3PL' : this.pageTitle === 'pallets'? this.pageTitle = 'Pallet Summary' : null;
      }
    })

    this._service.isLoggedIn$.subscribe(x => {
      this.userName = sessionStorage.getItem('name') || '';
      this.userRole = sessionStorage.getItem('role') || -1;
      this.userRole = parseInt(this.userRole);
      this.displayRole = this.roleTransform(this.userRole);
      this.userOrg = sessionStorage.getItem('org') || '';
      this.userOrgName = sessionStorage.getItem('orgName') || '';
      this.profileImg = sessionStorage.getItem('profileImg') !== 'null'? sessionStorage.getItem('profileImg') || '' : this.defaultAvatar;
    });

    this.currentProfile = parseInt(sessionStorage.getItem('currentProfile') || '');

    this._service.isLoggedIn$.subscribe(x => {
      if(x){
        this.lobList = [];
        this.orgList = sessionStorage.getItem('allowedOrgs');
        this.orgList = JSON.parse(this.orgList).sort((a: any, b: any) => (a.threeplName > b.threeplName) ? 1 : ((b.threeplName > a.threeplName) ? -1 : 0));
        this.orgList?.filter((_: any) => this.lobList.push(..._.lobs));
        this.lobList = this.lobList.reduce((a: any,b: any) => {
          if (a.indexOf(b) < 0 ) a.push(b);
          return a;
        },[]).sort().reverse();
        sessionStorage.setItem('lobList', JSON.stringify(this.lobList));

        this.currentLob = sessionStorage.getItem('currentLob') ||  this.lobList[0];
        this.currentLobDisplay = this.currentLob;
        this.lobColor = sessionStorage.getItem('lobcolor');
        this.lobColor = JSON.parse(this.lobColor as any);
        this.lobColor = this.lobColor? this.lobColor[this.currentLob] : null;
        sessionStorage.setItem('currentLob', this.currentLob);

        if(this.userRole === 0 || this.userRole === 1 || this.userRole === 99){
          this.orgList?.unshift({threeplId: 'Spirit', threeplName: null, lobs: ['CHRISTMAS', 'HALLOWEEN']});
          this.filterOrgList(this.currentLob);
        }
        else{
          this.orgListDisplay = this.orgList
        }
        this.currentOrg = sessionStorage.getItem('org') || this.setOrg(this.orgList);
        this.currentOrgDisplay = this.currentOrg;
        sessionStorage.setItem('org', this.currentOrg)
      }
    });

    window.addEventListener('storage', (e) => {
      if(e.storageArea == sessionStorage){
        this.toastr.error(`${this.labels.message.security}`, 'Warning', {
          timeOut: 3000,
        });
        this.logout();
      }
    })
  }

  setOrg(list: any){
    let ORG = 'dsfsdf';
    if(this.userRole === 0 || this.userRole === 1 || this.userRole === 99){
      ORG = list[0].threeplId
    }
    else{
      const INDEX = list.findIndex((_: any) => _.lobs[0].toLowerCase() === this.currentLob.toLowerCase());
      INDEX >=0? ORG = list[INDEX].threeplId : ORG = list[0].threeplId;
    }
    return ORG;
  }

  filterOrgList(lob: string){
    this.orgListDisplay = this.orgList?.filter((_: any) => _.lobs.includes(lob));
  }

  changeLob(){
    this.currentOrg !== 'Spirit'? this.currentOrg = null : null;
    this.filterOrgList(this.currentLob);
  }

  roleTransform(n: number){
    switch(n){
      case 0:
        return 'Admin';
        break;
      case 1:
        return 'Spirit Manager';
        break;
      case 2:
        return '3PL Manager';
        break;
      case 3:
        return '3PL User';
        break;
      case 99:
        return 'EV Admin';
        break;  
      default:
        return '';
        break;        
    }
  }

  

  logout(){
    let userEmail = sessionStorage.getItem('email');
    const PAYLOAD = {
      userName: userEmail
    };
    this._apiService.logout(PAYLOAD).subscribe(x => {
      sessionStorage.clear();
      this._service.isLoggedIn$.next(false);
      this.router.navigate(["/login"]);
    }, (error) => {
      alert(error.error.error);
    }, () => {});
  }

  redirectOrg(){
    this.currentOrg === 'Spirit'? sessionStorage.setItem('currentProfile', "0") : sessionStorage.setItem('currentProfile', "1");
    sessionStorage.setItem('org', this.currentOrg);
    const INDEX = this.orgList.findIndex((_: any) => _.threeplId.toLowerCase() === this.currentOrg.toLowerCase());
    if(this.userRole === 0 || this.userRole === 1 || this.userRole === 99)
      sessionStorage.setItem('currentLob', this.currentLob);
    else
      sessionStorage.setItem('currentLob', this.orgList[INDEX].lobs[0]);

    
    this.router.navigate(["/dashboard"]);
    setTimeout(() => {
      window.location.reload();
    }, 0);
  }

  
}
